import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'markdown',
  standalone: false,
})
export class MarkdownPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(this.parse(value));
  }

  private parse(text: string): string {
    const lines = text.split('\n');
    let html = '';
    let inList = false;

    for (const line of lines) {
      const trimmed = line.trim();

      if (trimmed.startsWith('- ') || trimmed.startsWith('* ')) {
        if (!inList) {
          html += '<ul>';
          inList = true;
        }
        html += `<li>${this.inline(trimmed.slice(2))}</li>`;
      } else {
        if (inList) {
          html += '</ul>';
          inList = false;
        }

        if (trimmed.startsWith('### ')) {
          html += `<h5>${this.inline(trimmed.slice(4))}</h5>`;
        } else if (trimmed.startsWith('## ')) {
          html += `<h4>${this.inline(trimmed.slice(3))}</h4>`;
        } else if (trimmed.startsWith('# ')) {
          html += `<h3>${this.inline(trimmed.slice(2))}</h3>`;
        } else if (trimmed === '') {
          // skip empty lines — block elements (p, h3-h5) already provide spacing
        } else {
          html += `<p>${this.inline(trimmed)}</p>`;
        }
      }
    }

    if (inList) {
      html += '</ul>';
    }

    return html;
  }

  private inline(text: string): string {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.+?)\*/g, '<em>$1</em>')
      .replace(
        /\[(.+?)\]\(((?:https?:\/\/|mailto:)[^)]+)\)/g,
        '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>',
      );
  }
}
